export default __webpack_public_path__ + "static/media/connection_successful.a42c3e3b.svg";